/**
 * Кегль і інтерліньяж тексту статті — в одному місці для абзаців, кроків і
 * врізок, щоб текст не стрибав між 16, 17 і 18 пікселями від блоку до блоку.
 *
 * 17px на телефоні, 18px від lg. Рядок 1.75: у довгому юридичному тексті
 * око має легко знаходити початок наступного рядка. Ширину рядка тримає
 * колонка статті (43rem від xl — близько 70 знаків), а не самі абзаци.
 */
export const bodyText = 'text-[1.0625rem] lg:text-lg leading-[1.75]';
